// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3o-1";
export var movingGradient = "_3o-4";
export var movingGradientBlock = "_3o-2";
export var skeleton = "_3o-0";
export var skeletonText = "_3o-3";